import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  private isPublicRoute(rawUrl: string) {
    const url = rawUrl && rawUrl.length > 1 && rawUrl.endsWith('/') ? rawUrl.slice(0, -1) : (rawUrl || '');
    const publicPrefixes = [
      '/tabs/signin',
      '/tabs/signup',
      '/tabs/forgot-password',
      '/tabs/new-account',
      '/signin',
      '/signup',
      '/forgot-password',
      '/new-account',
      '/rules',
      '/privacy-policy',
      '/stripe/privacy-policy',
      '/stripe/payment-success',
      '/stripe/payment-error',
    ];
    return publicPrefixes.some((p) => url.startsWith(p));
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = (typeof localStorage !== 'undefined') ? (localStorage.getItem('jwt') ? JSON.parse(localStorage.getItem('jwt') as any) : null) : null;
    
    let headers: any = {};
    if (token && !this.isExpired(token)) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    const request = req.clone({ setHeaders: headers });
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          try {
            localStorage.removeItem('jwt');
            localStorage.removeItem('user');
          } catch {}
          const currentUrl =
            (typeof window !== 'undefined' && window.location?.pathname)
              ? `${window.location.pathname}${window.location.search ?? ''}`
              : (this.router.url || '');
          if (!this.isPublicRoute(currentUrl)) {
            this.router.navigate(['/tabs/signin']);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private isExpired(token: string): boolean {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return true;
      const payload = JSON.parse(atob(parts[1]));
      const exp = Number(payload?.exp) || 0;
      if (!exp) return true;
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  }
}
